import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FieldContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.xl};
`;
